import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import Home from './screens/Home/Home';

const theme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#1B140E', // Warm Ink
            paper: '#261D15', // Raised Ink
        },
        primary: {
            main: '#D67C2E', // Shadowpilot Orange
            dark: '#B0631F',
        },
        secondary: {
            main: '#8B45C9', // Brain Violet
        },
        text: {
            primary: '#F5F0EB', // Paper White
            secondary: '#C2B09F', // Sand
        },
    },
    typography: {
        fontFamily: "'IBM Plex Sans', sans-serif",
        button: {
            textTransform: 'none',
            fontWeight: 600,
            letterSpacing: '0.01em',
        },
    },
    shape: {
        borderRadius: 10,
    },
});

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
                <Route path='/' element={<Home />} />
            </Routes>
        </ThemeProvider>
    );
}
